import { render, staticRenderFns } from "./cartNotification.vue?vue&type=template&id=4cb671df&scoped=true&"
import script from "./cartNotification.vue?vue&type=script&lang=js&"
export * from "./cartNotification.vue?vue&type=script&lang=js&"
import style0 from "./cartNotification.vue?vue&type=style&index=0&id=4cb671df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb671df",
  null
  
)

export default component.exports